import { render, staticRenderFns } from "./WinnerBoardWinner.vue?vue&type=template&id=65fde024&scoped=true"
import script from "./WinnerBoardWinner.vue?vue&type=script&lang=js"
export * from "./WinnerBoardWinner.vue?vue&type=script&lang=js"
import style0 from "./WinnerBoardWinner.vue?vue&type=style&index=0&id=65fde024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fde024",
  null
  
)

export default component.exports